module.exports = __webpack_public_path__ + "static/media/024.d3fb3bde.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/thumbs/024.jpg
// module id = 531
// module chunks = 0